export interface PurchaseContractForOrder {
  purchaseContractHeaderId: string;
  purchaseContractLineId: string;
  purchaseContractNumber: number;
  productId: string;
  productKey: string;
  productDescription: string;
  productTypeId: string;
  productTypeDescription: string;
  unitOfMeasureId: string;
  quantity: number;
  price: number;
  contractDetails: string;
}
